<template>
  <div class="reportWarm">
    <div>
      <p>
        <Icon type="android-alert" class="reportY"></Icon>
      </p>
      <p>您还有<span class="bolds">{{reportDay}}</span>天的日报没有处理</p>
      <p>
        <button @click="toPage()">立即处理</button>
      </p>
    </div>
  </div>
</template>

<script>
    export default {
      data(){
        return{
          reportDay:''
        }
      },
      props:[
        'userConfig'
      ],
      methods:{
        getReportDay(){
          this.$http.get(this.userConfig.apiName + '/v4/alertSupervise/supervisesDailyState').then(res=>{
            if(res.data.code == 0){
              this.$set(this,'reportDay',res.data.data.total);
              if(!this.reportDay){
                this.$root.reportHub.$emit('nowClick');
              }
            }
          })
        },
        toPage(){
          this.$router.push('/operation/alertReport');
        }
      },
      mounted(){
        if(this.userConfig){
          this.getReportDay();
        }
      }
    }
</script>

<style scoped lang="less">
.reportWarm {
  padding: 10px;
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 99;
  border: 1px solid #06907b;
  border-radius: 5px;
  background: #081623;
  p {
    padding: 5px 0;
    font-size: 16px;
    color: #0bfcd7;
    .bolds {
      font-size: 20px;
      font-weight: bold;
      color: yellow;
    }
    button {
      padding: 0 20px ;
      border: 1px solid #0bfcd7;
      color: #0bfcd7;
      background: transparent;
      border-radius: 4px;
    }
  }
  .reportY {
    font-size: 20px;
    color: yellow;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/reportWarm.vue